<template>
  <filter-parent v-if="showFilter" :title="roleTitle">
    <multiselect
      v-if="!isLoadingCompetenceAreas"
      v-model="titles"
      :multiple="true"
      :options="titleOptions"
      :placeholder="startTypingText"
    />
    <multiselect-filter-loader v-else />
  </filter-parent>
</template>

<script lang="ts">
import Multiselect from 'Components/MultiSelect.vue';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import FilterParent from '../common/FilterParent.vue';
import MultiselectFilterLoader from './MultiselectFilterLoader.vue';

export default defineComponent({

  components: {
    FilterParent,
    Multiselect,
    MultiselectFilterLoader,
  },

  computed: {
    ...mapState('counselorGrid', ['titleOptions', 'isLoadingCompetenceAreas']),

    roleTitle() {
      return this.texts.therapistTitle;
    },

    showFilter() {
      return this.isLoadingCompetenceAreas || this.titleOptions.length > 0;
    },

    titles: {
      get() {
        return this.$store.state.counselorGrid.filteredTitles;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredTitles', value);
      },
    },
  },

  data() {
    return {
      startTypingText: window.theme_vars.counselorGridTexts.startTyping,
      texts: window.theme_vars.counselorGridTexts,
    };
  },
  name: 'TitleFilter',
});
</script>
